<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CButton @click="collapse=!collapse" color="primary" class="mb-2">
                    فیلتر داده‌ها
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard>
                        <CCardHeader>
                            <strong>گزینه‌های فیلتر</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <label>کاربر</label>
                                    <model-select :options="users" v-model="form.user_id.val" placeholder="انتخاب کنید">
                                    </model-select>
                                    <small class="form-text text-muted w-100">{{form.user_id.inv}}</small>
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.billing_type.val"
                                        :description="form.billing_type.inv"
                                        label="نوع پرداخت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: '0', label: 'برداشت از موجودی'},
                                            {value: '1', label: 'پرداخت آنلاین'},
                                            {value: '2', label: 'هزینه بازگشتی روز'},
                                            {value: '3', label: 'هزینه ارسالی روز'},
                                            {value: '4', label: 'ثبت فیش'},
                                            {value: '5', label: 'افزودن موجودی'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.billing_type.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.state.val"
                                        :description="form.state.inv"
                                        label="وضعیت"
                                        :options="[
                                            {value: '', label: 'هیچ‌کدام'},
                                            {value: 'true', label: 'تایید شده'},
                                            {value: 'false', label: 'تایید نشده'}
                                        ]"
                                        placeholder="انتخاب کنید"
                                        @change="form.state.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <label>از تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.from_time.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.from_time.inv}}</small>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <label>تا تاریخ</label>
                                    <date-picker placeholder="انتخاب کنید" v-model="form.to_time.val"></date-picker>
                                    <small class="form-text text-muted w-100">{{form.to_time.inv}}</small>
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();filter=true;page=1;get_all();get();" class="ml" color="primary">فیلتر</CButton>
                                <CButton @click="remove_filter" color="danger">حذف فیلتر</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>مجموع</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable hover striped :items="all_items" :fields="all_fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                        </CDataTable>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol col="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>گزارش امور مالی</strong>
                        <div class="card-header-actions">
                            تعداد: {{row_count}}
                        </div>
                    </CCardHeader>
                    <CCardBody>
                        <CCol sm="5">
                            <CSelect v-model="limit" horizontal label="تعداد سطرها" :options="[
                                {value: 10}, {value: 20}, {value: 50}, {value: 100}]" class="row-count" placeholder="تعداد سطرها" @change="limit=$event.target.value" />
                        </CCol>
                        <CDataTable hover striped :items="items" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                            <template #user_name="data">
                                <td>
                                    <router-link :to="`/profile/${data.item.user_id}`">{{data.item.user_name}}</router-link>
                                </td>
                            </template>
                            <template #short_billing_details="data">
                                <td v-if="data.item.short_billing_details == '---'">{{data.item.short_billing_details}}</td>
                                <td v-else>
                                    <CButton @click="billing_modal=true;billing_details=data.item.full_billing_details"
                                    color="link">{{data.item.short_billing_details}}</CButton> 
                                </td>
                            </template>
                            <template #state="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.state)">
                                        {{data.item.state}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #billing_type="data">
                                <td>
                                    <CBadge :color="get_badge(data.item.billing_type)">
                                        {{data.item.billing_type}}
                                    </CBadge>
                                </td>
                            </template>
                            <template #action="data">
                                <td v-if="data.item.can_pay || data.item.can_delete ||
                                    (data.item.billing_type == 'ثبت فیش' && data.item.can_verify)
                                    || data.item.billing_type == 'پرداخت آنلاین'">
                                    <template>
                                        <div class="flex-container">
                                            <div v-show="data.item.can_pay"
                                                @click="pay_billing(data.item.id)"
                                                v-c-tooltip.hover="'پرداخت'">
                                            <CIcon name="cilDollar" size="lg"/>
                                            </div>
                                            <div v-show="data.item.can_delete"
                                                @click="delete_modal=true;id=data.item.id"
                                                v-c-tooltip.hover="'حذف'">
                                            <CIcon name="cilTrash" size="lg"/>
                                            </div>
                                            <div v-show="data.item.billing_type == 'ثبت فیش'
                                                && data.item.can_verify"
                                                @click="receipt_modal=true;id=data.item.id"
                                                v-c-tooltip.hover="'تعیین وضعیت'">
                                            <CIcon name="cilCheck" size="lg"/>
                                            </div>
                                            <div v-show="data.item.billing_type == 'پرداخت آنلاین'
                                                && data.item.success == true"
                                                @click="detail_modal=true;online_pay_detail=data.item"
                                                v-c-tooltip.hover="'جزییات'">
                                            <CIcon name="cilListRich" size="lg"/>
                                            </div>
                                        </div>
                                    </template>
                                </td>
                                <td v-else>---</td>
                            </template>
                        </CDataTable>
                            <br>
                            <div> 
                                <CPagination
                                :activePage.sync="page"
                                :pages="page_count"
                                align="center"
                                :doubleArrows="true"
                                />
                            </div>
                        </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آیا برای حذف شناسه {{id}} اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
        <CModal
            title="متن کامل توضیحات"
            size="sm"
            color="primary"
            :show.sync="billing_modal"
            >
            <p v-html="billing_details"></p>
            <template #footer>
                <CButton @click="billing_modal=false" color="primary">بستن</CButton>
            </template>
        </CModal>
        <CModal
			title="دقت کنید"
			size="sm"
			color="primary"
			:show.sync="receipt_modal"
			>
			<p>وضعیت فیش ثبت شده با شناسه {{id}} را مشخص کنید.</p>
			<template #footer>
				<CButton @click="receipt_status(false)" color="secondary">رد فیش</CButton>
				<CButton @click="receipt_status(true)" color="danger">تایید فیش</CButton>
			</template>
		</CModal>
        <CModal
            title="جزییات پرداخت آنلاین"
            size="sm"
            color="primary"
            :show.sync="detail_modal"
            >
            <p>کد پیگیری: {{online_pay_detail.RefID}}</p>
            <p>وضعیت: {{online_pay_detail.Status}}</p>
            <p>شماره کارت: {{online_pay_detail.MaskCardNumber}}</p>
            <p>IP: {{online_pay_detail.BuyerIP}}</p>
            <template #footer>
                <CButton @click="detail_modal=false" color="primary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data () {
        return {
            row_count: '',
            items: [],
            fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'user_name', label: 'کاربر' },
                { key: 'fee', label: 'مبلغ'},
                { key: 'billing_type', label: 'نوع پرداخت' },
                { key: 'short_billing_details', label: 'توضیحات' },
                { key: 'state', label: 'وضعیت' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'pay_at', label: 'تاریخ پرداخت' },
                { key: 'action', label: 'عملیات' }
            ],
            collapse: false,
            form: {
                user_id: { val: '', inv: '', v: { max: 8 } },
                billing_type: { val: '', inv: '', v: { max: 4 } },
                state: { val: '', inv: '', v: { max: 4 } },
                from_time: { val: '', inv: '', v: { max: 16 } },
                to_time: { val: '', inv: '', v: { max: 16 } },
            },
            filter: false,
            disable: false,
            page: 1,
            page_count: 0,
            offset: 0,
            limit: 10,
            billing_details: '',
            billing_modal: false,
            delete_modal: false,
            receipt_modal: false,
            detail_modal: false,
            online_pay_detail: '',
            users: [],
            id: 0,
            all_items: [],
            all_fields: [
                { key: 'afzodan_mojodi_sum', label: 'افزایش موجودی' },
                { key: 'bardashti_sum', label: 'برداشت از موجودی' },
                { key: 'hazine_bazgashti_roz_sum', label: 'هزینه بازگشتی روز' },
                { key: 'hazine_ersali_roz_sum', label: 'هزینه ارسالی روز' },
                { key: 'pardakht_online_sum', label: 'پرداخت آنلاین' },
                { key: 'sabt_fish_sum', label: 'ثبت فیش' },
            ],
        }
    },
    watch: {
        page: {
            handler(){
                this.get();
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },
        limit: {
            handler() {
                this.page = 1;
                this.get();
            }
        }
    },
    mounted(){
        this.get_all();
        this.get();
        this.get_users();
        this.result();
    },
    methods: {
        get_users(){
            this.axios.get('users/?type=view_bills')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.name}` });
                    });
                })
        },
        get_badge(status) {
            switch(status) {
                case 'تایید شده': return 'success'
                case 'تایید نشده': return 'danger'
                default: return 'secondary'
            }
        },
        get() {
            if (this.disable == false) {
                let filter = '';
                if(this.filter){
                    for (const key in this.form) {
                        if(this.form[key].val != ''){
                            if (key == 'from_time' || key == 'to_time') {
                                filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                            } else{
                                filter += `&${key}=` + this.form[key].val;
                            }
                        }
                    }
                }
                this.axios.get('user_billings/' 
                    + '?count=1' 
                    + filter)
                    .then(res => {
                        this.row_count = String(res.data.count).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        if(res.data.count > this.limit){
                            this.page_count = Math.ceil(res.data.count / this.limit);
                        } else {
                            this.page_count = 1;
                        }
                        this.offset = 0;
                        if(this.page != 1){
                            this.offset = (this.page * this.limit) - this.limit;
                        }
                    })
                .finally(() => {
                    this.axios.get('user_billings/' 
                        + '?limit=' + this.limit 
                        + '&offset=' + this.offset 
                        + '&user_info=1' 
                        + '&pay_info=1' 
                        + filter)
                        .then(res => {
                            res.data.map(val => {
                                val.user_name = `${val.user_info.first_name} ${val.user_info.last_name}`;
                                switch(val.billing_type){
                                    case 1:
                                        if(val.success == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            val.state = 'تایید نشده';
                                        }
                                        val.billing_type = 'پرداخت آنلاین';
                                        val.RefID = val.pay_info.RefID;
                                        val.BuyerIP = val.pay_info.BuyerIP;
                                        val.Status = val.pay_info.Status;
                                        if(val.pay_info.MaskCardNumber != ''){
                                            val.MaskCardNumber = val.pay_info.MaskCardNumber;
                                        } else {
                                            val.MaskCardNumber = '---';
                                        } 
                                        break;
                                    case 4:
                                        if(val.success == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            if(val.can_verify == true){
                                                val.state = 'مشخص نشده';
                                            } else {
                                                val.state = 'تایید نشده';
                                            }
                                        }
                                        val.billing_type = 'ثبت فیش';
                                        break;
                                    case 0:
                                        if(val.state == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            val.state = 'تایید نشده';
                                        }
                                        val.billing_type = 'برداشت از موجودی';
                                        break;
                                    case 3:
                                        if(val.state == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            val.state = 'تایید نشده';
                                        }
                                        val.billing_type = 'هزینه ارسالی روز';
                                        break;
                                    case 2:
                                        if(val.state == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            val.state = 'تایید نشده';
                                        }
                                        val.billing_type = 'هزینه بازگشتی روز';
                                        break;
                                    case 5:
                                        if(val.state == true){
                                            val.state = 'تایید شده';
                                        } else {
                                            val.state = 'تایید نشده';
                                        }
                                        val.billing_type = 'افزودن موجودی';
                                        break;
                                }
                                val.fee = String(val.fee).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                if(val.pay_at == '0001-01-01T00:00:00Z'){
                                    val.pay_at = '---';
                                } else {
                                    val.pay_at = this.$moment(val.pay_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                                }
                                if(val.billing_details != ''){
                                    if(val.billing_details.length > 20){
                                        val.full_billing_details = val.billing_details;
                                        val.short_billing_details = val.full_billing_details.substring(0, 20);
                                        val.short_billing_details += '...';
                                    } else {
                                        val.full_billing_details =  val.short_billing_details = val.billing_details;
                                    }
                                } else{
                                    val.short_billing_details = '---';
                                }
                            });
                            this.items = res.data;
                        })
                })
            }
        },
        get_all() {
            let filter = '';
            if(this.filter){
                for (const key in this.form) {
                    if(this.form[key].val != ''){
                        if (key == 'from_time' || key == 'to_time') {
                            filter += `&${key}=` + this.$moment(this.form[key].val, 'jYYYY-jMM-jDD').locale('es').format('YYYY-MM-DD');
                        } else{
                            filter += `&${key}=` + this.form[key].val;
                        }
                    }
                }
            }
            this.axios.get('user_billings/' 
                + '?all_billings=1'
                + '&user_info=1' 
                + '&pay_info=1' 
                + filter)
                .then(res => {
                    for(const key in res.data){
                        res.data[key] = String(res.data[key]).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    this.all_items = [res.data];
                })
        },
        remove_filter() {
            for (const key in this.form) {
                this.form[key].val = '';
                this.form[key].inv = '';
            }
            this.disable = false;
            this.filter = false;
            this.page = 1;
            this.get_all();
            this.get();
        },
        pay_billing(id){
            const data = new FormData();
            data.set('id', id);
            this.axios.post('pay_bills/', data)
            .then(res => {
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'در حال انتقال به درگاه پرداخت...'
                });
                window.location = res.data.data.PaymentUrl;
            })
            .catch(() => {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    text: 'انتقال به درگاه پرداخت انجام نشد! لطفا مجددا تلاش کنید.'
                });
            });
        },
        result(){
            if(this.$route.params.result == '1'){
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'پرداخت آنلاین با موفقیت انجام شد.'
                });
            } else if(this.$route.params.result == '0'){
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    text: 'خطا در پرداخت آنلاین! لطفا مجددا تلاش کنید.'
                });
            }
        },
        delete_row() {
			this.axios.delete('user_billings/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
                this.delete_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
                    text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
        },
        receipt_status(state){
            const data = new FormData();
            data.set('id', this.id);
            if(state){
               data.set('state', true); 
            } else{
                data.set('state', false);
            }
            this.axios.delete('user_billings/', data)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'تعیین وضعیت فیش با موفقیت انجام شد.'
                });
                this.receipt_modal = false;
				this.get();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.receipt_modal = false;
			})
        }
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_bill_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
